import React,{useState} from "react";
import Helper from '../functions/Helper.js';
import useWindowSize from '../hooks/useWindowSize.js';
import Spinner from "react-bootstrap/Spinner";
/** @jsx jsx */
import {jsx} from '@emotion/core'
import { useSwipeable } from 'react-swipeable';
//import Swipe from 'react-easy-swipe';

export default function Gallery(props){
  const handlers = useSwipeable({
  onSwipedLeft: ()=>{prevPic()},
  onSwipedRight:()=>{nextPic()},
  preventDefaultTouchmoveEvent: true,
    trackMouse: true
});

  const nextPic=()=>{setLoaded(false);props.setActiveSlide(props.activeSlide+1 >= props.pictures.length ? 0 : props.activeSlide+1 )}
  const prevPic=()=>{setLoaded(false);props.setActiveSlide(props.activeSlide-1 <0 ? props.pictures.length-1 : props.activeSlide-1 )}

  const size = useWindowSize();
  const [loaded,setLoaded]=useState(false);
  let picture=props.pictures[props.activeSlide];

  if(picture!==undefined){
    return(
      <div  {...handlers} style={{animation:"fadein 0.5s",display:props.showGallery? "flex" :"none",alignItems:"center",justifyContent:"center",zIndex:100000,left:0,top:0,bottom:0,right:0,position:"fixed",backgroundColor:"#f5f5f5"}}>
        <button style={{
            padding:0,
            backgroundColor:"transparent",
            height:30,
            backgroundPosition:"center",
            backgroundRepeat:"no-repeat",
            border:0,
            width:30,
            right:25,
            top:25,
            position:"fixed",
            backgroundImage: 'url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2024%2024%22%3E%0A%09%3Cpath%20fill%3D%22%23000%22%20d%3D%22M21%204.41L19.59%203%2012%2010.59%204.41%203%203%204.41%2010.59%2012%203%2019.59%204.41%2021%2012%2013.41%2019.59%2021%2021%2019.59%2013.41%2012%2021%204.41z%22/%3E%0A%3C/svg%3E)'
          }}
          onClick={()=>{props.closeGallery()}}
          aria-label="Close">
        </button>
        <span onClick={nextPic}
          css={{
            "&:hover":{
              opacity:1
            },
            top:"85%",
            marginTop:-20,
            width:60,
            cursor:"pointer",
            height:60,
            opacity:0.4,
            backgroundSize:"100%",
            backgroundPosition:"center",
            backgroundRepeat:"no-repeat",
            border:0,
            position:"fixed",
            right:"30%",
            backgroundImage:'url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2024%2024%22%3E%0A%09%3Cpath%20fill%3D%22%23333%22%20d%3D%22M8.59%2016.59L13.17%2012%208.59%207.41%2010%206l6%206-6%206-1.41-1.41z%22/%3E%0A%3C/svg%3E)',
            "@media (min-width:768px)":{
              top:"50%",
              right:10
            }
          }} title="next"/>
        <span onClick={prevPic}
          css={{
            "&:hover":{
              opacity:1
            },
            marginTop:-20,
            width:60,
            cursor:"pointer",
            height:60,
            opacity:0.4,
            backgroundSize:"100%",
            backgroundPosition:"center",
            backgroundRepeat:"no-repeat",
            border:0,
            position:"fixed",
            top:"85%",
            left:"30%",
            backgroundImage:'url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2024%2024%22%3E%0A%09%3Cpath%20fill%3D%22%23000%22%20d%3D%22M15.41%207.41L10.83%2012l4.58%204.59L14%2018l-6-6%206-6%201.41%201.41z%22/%3E%0A%3C/svg%3E)',
            "@media (min-width:768px)":{
              top:"50%",
              left:10,
            }
          }}
          title="next"/>
        {size.width!==undefined &&
        <picture id="düdel" key={picture.picture_id}>
          <source
            type="image/webp"
            data-srcset={Helper.create_source_set(picture,undefined,"webp")}
            sizes = "70vw"
            />
          <source
            type="image/png"
            data-srcset={Helper.create_source_set(picture)}
            sizes="70vw"
            />
          <img className="lazyload" onLoad={()=>{setLoaded(true)}}
              style={{
                opacity:loaded ? 1:0,
                transition:"opacity 0.5s",
                width:size.width > 768 ? size.width*0.7 : size.width*0.95 ,
                height:size.width > 768 ? size.height*0.7 : size.width*0.95,
                objectFit:"contain",
                position:"relative"
              }}
              width={picture.width} height={picture.height}
              data-src={Helper.add_options_img(picture.master,585)}
              sizes="70vw"
              data-srcset={Helper.create_source_set({master:picture.master,thumbnails:"1"})}/>
            {!loaded &&  <Spinner style={{position:"absolute",top:"50%",marginTop:"-0.5rem",marginLeft:"-1rem",left:"50%"}} animation="border" variant="primary"/>}
        </picture>}
      </div>
    );
  }
  else{
    return(null)
  }
}
